"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var language = {};
language.translations = {};
language.translations.options = {
  months: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
  },
  shortMonths: {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec'
  },
  weekdays: {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday'
  },
  shortWeekdays: {
    1: 'Mon',
    2: 'Tue',
    3: 'Wed',
    4: 'Thu',
    5: 'Fri',
    6: 'Sat',
    7: 'Sun'
  }
};
language.translations.global = {};
var _default = exports["default"] = language;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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